// extracted by mini-css-extract-plugin
module.exports = {"heroPromotionalBanners":"SearchPage_heroPromotionalBanners__wu9oz","section":"SearchPage_section__TsZMI","bannerWrapper":"SearchPage_bannerWrapper__jNkvl"};